"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputVals = exports.getVideoData = void 0;
var utilities_1 = require("./utilities");
var formatting_1 = require("@rmlibrary/formatting");
var clipsToReset = [];
// const videoContainer = document.getElementById("video-container");
var videoContainer = document.getElementsByTagName("rm-dynamic-video")[0];
var landingPageContainer = document.getElementById("landing-page-container");
var watchVideoBtn = document.getElementById("watch-video-button");
var nameInput = document.getElementById("name");
var currentSavingsInput = document.getElementById("current-savings");
var monthlySavingsInput = document.getElementById("monthly-savings");
var goalInput = document.getElementById("goal");
var savingReasonInput = document.getElementById("saving-reason");
var currentSavingsInputVal = currentSavingsInput.value;
var monthlySavingsInputVal = monthlySavingsInput.value;
var goalInputVal = goalInput.value;
var savingReasonInputVal = savingReasonInput.value;
watchVideoBtn === null || watchVideoBtn === void 0 ? void 0 : watchVideoBtn.addEventListener("click", function () {
    if (validateInputs())
        return;
    var data = getVideoData();
    var embedMode = (0, utilities_1.hasQueryStringInURL)("embed");
    videoContainer.initVideo(data, embedMode);
    videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer.classList.remove("hidden");
    landingPageContainer === null || landingPageContainer === void 0 ? void 0 : landingPageContainer.classList.add("hidden");
});
nameInput === null || nameInput === void 0 ? void 0 : nameInput.addEventListener("keyup", function (key) {
    if (key.code == "Space")
        nameInput.value = nameInput.value.replace(/\s/g, '');
});
function validateInputs() {
    var inputVals = getInputVals();
    var _err = false;
    if ((0, formatting_1.parseNumber)(inputVals.currentSavings) >= (0, formatting_1.parseNumber)(inputVals.goal)) {
        document.querySelectorAll(".input-row")[1].querySelector(".err-msg").style.display = "block";
        _err = true;
    }
    else if ((0, formatting_1.parseNumber)(inputVals.currentSavings) <= (0, formatting_1.parseNumber)(inputVals.goal)) {
        document.querySelectorAll(".input-row")[1].querySelector(".err-msg").style.display = "none";
    }
    if (inputVals.monthlySavings == "NaN" || inputVals.monthlySavings == "0") {
        document.querySelectorAll(".input-row")[2].querySelector(".err-msg").style.display = "block";
        _err = true;
    }
    else if (inputVals.monthlySavings !== "NaN" && inputVals.monthlySavings !== "0") {
        document.querySelectorAll(".input-row")[2].querySelector(".err-msg").style.display = "none";
    }
    if (inputVals.goal == "NaN" || inputVals.goal == "0") {
        document.querySelectorAll(".input-row")[3].querySelector(".err-msg").style.display = "block";
        _err = true;
    }
    else if (inputVals.goal !== "NaN" && inputVals.goal !== "0") {
        document.querySelectorAll(".input-row")[3].querySelector(".err-msg").style.display = "none";
    }
    //check if the 10% savings is at least saving 1 month or not exceeding 30 years
    var _currSavings = (0, formatting_1.parseNumber)(inputVals.currentSavings);
    var _goalVal = (0, formatting_1.parseNumber)(inputVals.goal);
    var _monthlySavings = (0, formatting_1.parseNumber)(inputVals.monthlySavings);
    var _regularMonths = Math.ceil((_goalVal - _currSavings) / _monthlySavings);
    var _10plusMonths = Math.ceil((_goalVal - _currSavings) / (_monthlySavings * 1.1));
    var _20plusMonths = Math.ceil((_goalVal - _currSavings) / (_monthlySavings * 1.2));
    var currentSavingsInputMax = (0, formatting_1.parseNumber)(currentSavingsInput.dataset.maxLimit || "0");
    var monthlySavingsInputMax = (0, formatting_1.parseNumber)(monthlySavingsInput.dataset.maxLimit || "0");
    var goalInputMax = (0, formatting_1.parseNumber)(goalInput.dataset.maxLimit || "0");
    if (_regularMonths - _10plusMonths < 1 || _10plusMonths - _20plusMonths < 1) {
        document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg").forEach(function (errMsg) {
            errMsg.style.display = "none";
        });
        if (_goalVal < goalInputMax) {
            if ((0, formatting_1.parseNumber)(inputVals.currentSavings) < (0, formatting_1.parseNumber)(inputVals.goal)) {
                document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg")[1].style.display = "block";
            }
        }
        else {
            if ((0, formatting_1.parseNumber)(inputVals.currentSavings) >= (0, formatting_1.parseNumber)(inputVals.goal)) {
                document.querySelectorAll(".input-row")[1].querySelector(".err-msg").style.display = "none";
            }
            document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg")[3].style.display = "block";
        }
        _err = true;
    }
    else {
        document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg")[1].style.display = "none";
        document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg")[3].style.display = "none";
    }
    if (_regularMonths > 360) {
        document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg").forEach(function (errMsg) {
            errMsg.style.display = "none";
        });
        document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg")[2].style.display = "block";
        _err = true;
    }
    else {
        document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg")[2].style.display = "none";
    }
    if (_currSavings > currentSavingsInputMax) {
        // currentSavingsInput.value = formatNumber(currentSavingsInputMax);
        document.querySelectorAll(".input-row")[1].querySelectorAll(".err-msg").forEach(function (errMsg) {
            errMsg.style.display = "none";
        });
        document.querySelectorAll(".input-row")[1].querySelectorAll(".err-msg")[1].style.display = "block";
        _err = true;
    }
    else {
        document.querySelectorAll(".input-row")[1].querySelectorAll(".err-msg")[1].style.display = "none";
    }
    if (_monthlySavings > monthlySavingsInputMax) {
        // monthlySavingsInput.value = formatNumber(monthlySavingsInputMax);
        document.querySelectorAll(".input-row")[2].querySelectorAll(".err-msg").forEach(function (errMsg) {
            errMsg.style.display = "none";
        });
        document.querySelectorAll(".input-row")[2].querySelectorAll(".err-msg")[1].style.display = "block";
        _err = true;
    }
    else {
        document.querySelectorAll(".input-row")[2].querySelectorAll(".err-msg")[1].style.display = "none";
    }
    if (_goalVal > goalInputMax) {
        // goalInput.value = formatNumber(goalInputMax);
        document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg").forEach(function (errMsg) {
            errMsg.style.display = "none";
        });
        document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg")[4].style.display = "block";
        _err = true;
    }
    else {
        document.querySelectorAll(".input-row")[3].querySelectorAll(".err-msg")[4].style.display = "none";
    }
    if (inputVals.name == "")
        inputVals.name = "Hi";
    return _err;
}
// TODO: Modify function to include logic to build timeline from Animate sections.
function buildTimeline() {
    if (parseInt(currentSavingsInput.value) > 0 && savingReasonInput.value == "other") {
        return [
            "S1-introduction-goal-other",
            "S3-how-does-it-work",
            "S4-pedestal-goal-".concat(savingReasonInput.value),
            "S5-wondering-how",
            "S6-off-to-great-start",
            "S7-by-saving",
            "S8-you-can-increase",
            "S9-increasing-10",
            "S10-increasing-20",
            "S11-remember",
            "S12-ending-goal-".concat(savingReasonInput.value),
            "S13-conclusion"
        ];
    }
    else if (parseInt(currentSavingsInput.value) > 0) {
        return [
            "S1-introduction",
            "S2-intro-goal-".concat(savingReasonInput.value),
            "S3-how-does-it-work",
            "S4-pedestal-goal-".concat(savingReasonInput.value),
            "S5-wondering-how",
            "S6-off-to-great-start",
            "S7-by-saving",
            "S8-you-can-increase",
            "S9-increasing-10",
            "S10-increasing-20",
            "S11-remember",
            "S12-ending-goal-".concat(savingReasonInput.value),
            "S13-conclusion"
        ];
    }
    else if (savingReasonInput.value == "other") {
        return [
            "S1-introduction-goal-other",
            "S3-how-does-it-work",
            "S4-pedestal-goal-".concat(savingReasonInput.value),
            "S5-wondering-how-no-savings",
            "S7-by-saving-no-savings",
            "S8-you-can-increase",
            "S9-increasing-10",
            "S10-increasing-20",
            "S11-remember",
            "S12-ending-goal-".concat(savingReasonInput.value),
            "S13-conclusion"
        ];
    }
    else {
        return [
            "S1-introduction",
            "S2-intro-goal-".concat(savingReasonInput.value),
            "S3-how-does-it-work",
            "S4-pedestal-goal-".concat(savingReasonInput.value),
            "S5-wondering-how-no-savings",
            "S7-by-saving-no-savings",
            "S8-you-can-increase",
            "S9-increasing-10",
            "S10-increasing-20",
            "S11-remember",
            "S12-ending-goal-".concat(savingReasonInput.value),
            "S13-conclusion"
        ];
    }
}
// TODO: Modify function to return an object to be passed as stage variables to the canvas player.
function getVideoData() {
    var timeline = buildTimeline();
    var savingsGoal = 0;
    return { clipsToReset: clipsToReset, timeline: timeline, savingsGoal: savingsGoal };
}
exports.getVideoData = getVideoData;
[currentSavingsInput, monthlySavingsInput, goalInput].forEach(function (elem) {
    elem.addEventListener("change", function (ev) {
        var value = ev.target.value;
        var numValue = (0, formatting_1.parseNumber)(value) || 0;
        var _fomattedVal = (0, formatting_1.formatNumber)(numValue);
        ev.target.value = _fomattedVal;
        validateInputs();
    });
});
function getInputVals() {
    var monthlySavings = (0, formatting_1.parseNumber)(monthlySavingsInput.value);
    var monthlySavings10 = Math.round(monthlySavings * 1.1);
    var monthlySavings20 = Math.round(monthlySavings * 1.2);
    var currentSavings = (0, formatting_1.parseNumber)(currentSavingsInput.value) || 0;
    var savingsGoal = (0, formatting_1.parseNumber)(goalInput.value);
    var goalTime = Math.ceil((savingsGoal - currentSavings) / monthlySavings);
    var goalTime10 = Math.ceil((savingsGoal - currentSavings) / monthlySavings10);
    var goalTime20 = Math.ceil((savingsGoal - currentSavings) / monthlySavings20);
    return {
        name: nameInput.value || "Hi",
        currentSavings: String(currentSavings),
        monthlySavings: String(monthlySavings),
        monthlySavings10: String(monthlySavings10),
        monthlySavings20: String(monthlySavings20),
        goal: String(savingsGoal),
        savingsReason: savingReasonInput.value,
        normalTime: String(goalTime),
        time10: String(goalTime10),
        time20: String(goalTime20)
    };
}
exports.getInputVals = getInputVals;
//# sourceMappingURL=module.js.map